<template>
  <div :menu-fix="true">
    <div class="wrapper">
      <breadcrumb :crumbs="[$t('menu.supplierSettlements'), $t('text.list')]">
        <el-button
          type="success"
          size="mini"
          v-if="
            !Permit.isFreeEdition() ||
            (Permit.isFreeEdition() &&
              Permit.currentTenant() &&
              Permit.currentTenant().charge.availableDays > 0)
          "
          @click="add"
          >+ {{ $t("text.create") }}</el-button
        >
      </breadcrumb>
    </div>
    <div class="search">
      <el-form
        :inline="true"
        @submit.native.prevent="search"
        :model="searchForm"
        size="small"
      >
        <el-form-item>
          <el-input
            v-model.trim="searchForm.title"
            :placeholder="$t('settlement.title')"
            size="small"
          />
        </el-form-item>
        <el-form-item>
          <el-select
            size="small"
            v-model.trim="searchForm.supplierName"
            :placeholder="$t('menu.suppliers')"
            filterable
            clearable
          >
            <el-option
              v-for="supplier in suppliers"
              :key="supplier.id"
              :label="supplier.name"
              :value="supplier.name"
            />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-search"
            native-type="submit"
          />
        </el-form-item>
      </el-form>
    </div>
    <div class="wrapper table-area">
      <sticky
        :sticky-top="50"
        :viewport="1024"
        :is-rem="false"
        style="min-height: 52px"
      >
        <vxe-toolbar ref="recordsToolbar" zoom class="table-toolbar">
          <template v-slot:buttons>
            <el-popover
              placement="left"
              width="600"
              trigger="click"
              @show="getSupplierCount"
            >
              <vxe-table
                :data="supplierCounts"
                row-id="id"
                ref="supplierCountsTable"
                class="recordsTable"
                size="mini"
                resizable
                round
                auto-resize
                highlight-hover-row
              >
                <vxe-table-column
                  field="supplierName"
                  :title="$t('menu.suppliers')"
                  min-width="80"
                />
                <vxe-table-column
                  field="amount"
                  :title="$t('settlement.amount')"
                  min-width="80"
                >
                  <template v-slot="{ row }">
                    <currency :code="row.currency"></currency>
                    {{ row.amount }}
                  </template>
                </vxe-table-column>
                <vxe-table-column
                  field="giveAmount"
                  :title="$t('settlement.giveAmount')"
                  min-width="80"
                >
                  <template v-slot="{ row }">
                    <currency :code="row.currency"></currency>
                    {{ row.giveAmount }}
                  </template>
                </vxe-table-column>
                <vxe-table-column
                  field="payAmount"
                  :title="$t('settlement.payAmountConfirm')"
                  min-width="80"
                >
                  <template v-slot="{ row }">
                    <currency :code="row.currency"></currency>
                    {{ row.payAmount }}
                  </template>
                </vxe-table-column>
                <vxe-table-column
                  field="diffAmount"
                  :title="$t('settlement.diffAmount')"
                  min-width="80"
                >
                  <template v-slot="{ row }">
                    <currency :code="row.currency"></currency>
                    {{ row.diffAmount }}
                  </template>
                </vxe-table-column>
              </vxe-table>
              <el-button
                slot="reference"
                type="defult"
                size="mini"
                class="float-right"
              >
                {{ $t("action.supplierSettlementCount") }}
              </el-button>
            </el-popover>
          </template>
        </vxe-toolbar>
      </sticky>
      <vxe-table
        :data="records"
        :loading="loading"
        id="stockInsTable"
        row-id="id"
        ref="recordsTable"
        class="recordsTable"
        size="mini"
        resizable
        round
        auto-resize
        highlight-hover-row
        :scroll-y="{ enabled: false }"
      >
        <vxe-table-column
          field="title"
          :title="$t('settlement.title')"
          min-width="130"
        >
          <template v-slot="{ row }">
            <span class="blue" @click="showRow(row)">{{ row.title }}</span>
            <div class="font14 blue-dark strong" @click="showDetail(row)">
              查看{{ $t("text.lineItem") }}
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="supplierName"
          :title="$t('menu.suppliers')"
          min-width="100"
        >
          <template v-slot="{ row }">
            {{ row.supplierName }}
            <div class="font10">
              {{ $t("settlement.directionsSupplier." + row.settleType) }}
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="orderQuantity"
          :title="$t('settlement.purchaseQuantity')"
          min-width="80"
        />
        <vxe-table-column
          field="productQuantity"
          :title="$t('settlement.productQuantity')"
          min-width="80"
        />
        <vxe-table-column
          field="amount"
          :title="$t('settlement.amount')"
          min-width="80"
        >
          <template v-slot="{ row }">
            <currency :code="row.currency"></currency>
            {{ row.amount }}
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="payAmount"
          :title="$t('settlement.giveAmountPayAmount')"
          min-width="110"
        >
          <template v-slot="{ row }">
            <el-popover
              placement="right"
              width="600"
              trigger="click"
              @show="getPayments(row)"
            >
              <vxe-table :data="payments" size="mini">
                <vxe-table-column
                  field="total"
                  :title="$t('payment.total')"
                  min-width="80"
                >
                  <template v-slot="{ row }">
                    <currency :code="row.currency"></currency>
                    {{ row.total }}
                  </template>
                </vxe-table-column>
                <vxe-table-column
                  field="payMethodName"
                  :title="$t('payment.payMethod')"
                  min-width="100"
                ></vxe-table-column>
                <vxe-table-column
                  field="paidAt"
                  :title="$t('payment.paidAt')"
                  min-width="110"
                ></vxe-table-column>

                <vxe-table-column
                  field="voucher"
                  :title="$t('payment.voucher')"
                  min-width="100"
                >
                  <template v-slot="{ row }">
                    <thumbnail-text :srcs="row.voucher" />
                  </template>
                </vxe-table-column>
                <vxe-table-column
                  field="explain"
                  :title="$t('payment.explain')"
                  min-width="80"
                >
                  <template v-slot="{ row }">
                    <raw-html-limit-number :content="row.explain" :number="8" />
                  </template>
                </vxe-table-column>
                <vxe-table-column
                  field="confirmAt"
                  :title="$t('order.confirmAt')"
                  min-width="110"
                ></vxe-table-column>
              </vxe-table>
              <span slot="reference" class="popover-reference">
                <currency :code="row.currency"></currency>
                {{ row.giveAmount }}/<currency :code="row.currency"></currency
                >{{ row.payAmount }}
              </span>
            </el-popover>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="diffAmount"
          :title="$t('settlement.diffAmount')"
          min-width="80"
        >
          <template v-slot="{ row }">
            <span
              class="red"
              v-if="row.payoffAt == null && row.amount - row.giveAmount > 0"
            >
              <currency :code="row.currency"></currency>
              {{ row.amount - row.giveAmount }}
            </span>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="selfVerifyAt"
          :title="$t('settlement.selfVerifyAt')"
          min-width="110"
        />
        <vxe-table-column
          field="verifyAt"
          :title="$t('settlement.verifyAt')"
          min-width="110"
        />
        <vxe-table-column
          field="payoffAt"
          :title="$t('settlement.payoffAt')"
          min-width="110"
        />
        <vxe-table-column
          field="settleAt"
          :title="$t('text.createAt')"
          min-width="110"
        />
        <vxe-table-column field="action" :title="$t('text.action')" width="110">
          <template v-slot="{ row, rowIndex }">
            <span
              v-if="
                row.settleType == 'Purchase' &&
                row.verifyAt == null &&
                row.payoffAt == null
              "
            >
              <el-button type="text" size="mini" @click="edit(row, rowIndex)">{{
                $t("text.edit")
              }}</el-button>

              <el-button type="text" size="mini" @click="deleteRow(row)">{{
                $t("text.delete")
              }}</el-button>
            </span>

            <div>
              <el-button
                v-if="row.verifyAt == null && row.settleType == 'Order'"
                type="text"
                size="mini"
                @click="verify(row, rowIndex)"
                >{{ $t("action.otherVerify") }}</el-button
              >
              <!-- <el-button
                v-if="row.payoffAt == null"
                type="text"
                size="mini"
                @click="confirmPayOff(row, rowIndex)"
                >{{ $t("action.paymentOff") }}</el-button
              > -->
              <el-button
                v-if="row.selfVerifyAt == null && row.settleType == 'Purchase'"
                type="text"
                size="mini"
                @click="selfVerify(row, rowIndex)"
                >{{ $t("action.selfVerify") }}</el-button
              >
            </div>
            <div>
              <el-button
                v-if="row.verifyAt == null && row.settleType == 'Order'"
                type="text"
                plain
                size="small"
                @click="
                  $router.push(
                    '/fnReport/fn-reports/supplier-settlements/intelligent-check/' +
                      row.id
                  )
                "
                >{{ $t("action.intelligentCheck") }}</el-button
              >
            </div>
          </template>
        </vxe-table-column>
      </vxe-table>

      <div class="flex flex-between pager">
        <div class="selected-qty-tips">
          选中了
          <span class="strong">{{ selectRecordQty }}</span>
          条记录
        </div>
        <div>
          <vxe-pager
            size="small"
            :loading="false"
            :background="false"
            :current-page="pager.currentPage"
            :page-size="pager.pageSize"
            :total="pager.total"
            :layouts="pagerConfig.layouts"
            :page-sizes="pagerConfig.pageSizes"
            @page-change="changePager"
          ></vxe-pager>
        </div>
      </div>
    </div>
    <drawer
      :title="$t('text.view')"
      :visible.sync="showDF"
      size="900px"
      direction="rtl"
      :wrapper-closable="false"
      :destroy-on-close="true"
    >
      <show :id="currentRowId" @updateData="showClose" />
    </drawer>

    <!-- 编辑 -->
    <el-dialog
      :title="$t('rules.edit', [$t('settlement.title')])"
      :visible.sync="editDF"
      :close-on-click-modal="false"
      width="30%"
    >
      <el-form ref="editObjForm" :model="editObj" label-width="60px">
        <el-form-item
          :label="$t('settlement.title')"
          :prop="'title'"
          :rules="[
            { required: true, validator: validateTitleEdit, trigger: 'blur' },
          ]"
        >
          <el-input size="small" v-model.trim="editObj.title" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="editDoing"
          size="small"
          @click="editSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="editDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>

    <!-- 新增 -->
    <el-dialog
      :title="$t('text.create')"
      :visible.sync="addDF"
      :close-on-click-modal="false"
      width="50%"
    >
      <el-form ref="addObjForm" :model="addObj" label-width="80px">
        <el-row>
          <el-col :span="12">
            <el-form-item
              :label="$t('menu.suppliers')"
              :prop="'supplierId'"
              :rules="[
                {
                  required: true,
                  message: $t('rules.required', [$t('menu.suppliers')]),
                  trigger: 'blur',
                },
              ]"
            >
              <el-select
                size="small"
                v-model.trim="addObj.supplierId"
                filterable
                clearable
                @change="selectSupplier"
              >
                <el-option
                  v-for="supplier in suppliers"
                  :key="supplier.id"
                  :label="supplier.text"
                  :value="supplier.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$t('settlement.title')"
              :prop="'title'"
              :rules="[
                { required: true, validator: validateTitle, trigger: 'blur' },
              ]"
            >
              <el-input size="small" v-model.trim="addObj.title" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item
              :label="$t('settlement.dateType')"
              :prop="'_dateType'"
              :rules="[
                {
                  required: true,
                  message: $t('rules.required', [$t('settlement.dateType')]),
                  trigger: 'blur',
                },
              ]"
            >
              <el-select
                size="small"
                v-model="addObj._dateType"
                clearable
                filterable
              >
                <el-option
                  v-for="dateType in dateTypes"
                  :key="dateType"
                  :label="$t('dateTypes.' + dateType)"
                  :value="dateType"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$t('settlement.dateRange')"
              :prop="'_date'"
              :rules="[
                {
                  required: true,
                  message: $t('rules.required', [$t('settlement.dateRange')]),
                  trigger: 'blur',
                },
              ]"
            >
              <el-date-picker
                size="small"
                v-model="addObj._date"
                type="daterange"
                range-separator="-"
                :start-placeholder="$t('text.startAt')"
                :end-placeholder="$t('text.endAt')"
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="addDoing"
          size="small"
          @click="addSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="addDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>

    <el-dialog
      :title="$t('text.lineItem')"
      v-if="lineItemDF"
      :visible.sync="lineItemDF"
      :close-on-click-modal="false"
      width="90%"
    >
      <line-item :id="currentRowId" @close="lineItemClose" />
    </el-dialog>
  </div>
</template>
<script>
import Vue from "vue";
import { page, table } from "@/utils/mixins.js";
import Util from "@/utils";
import Currency from "@/components/Currency";
import ThumbnailText from "@/components/ThumbnailText";
import RawHtmlLimitNumber from "@/components/RawHtmlLimitNumber";

import Show from "./show";
import LineItem from "./lineItem";

import Settlement from "@/api/settlement.js";
import Payment from "@/api/payment.js";
import Supplier from "@/api/supplier.js";
import Purchase from "@/api/purchase.js";

export default {
  mixins: [
    page,
    table.pager,
    table.narrow,
    table.search,
    table.checker,
    table.sorter,
    table.basic,
  ],
  components: {
    Currency,
    Show,
    ThumbnailText,
    RawHtmlLimitNumber,
    LineItem,
  },
  data() {
    var validateTitleEdit = (rule, value, callback) => {
      const self = this;
      if (value == null || value === "") {
        callback(
          new Error(self.$t("rules.required", [self.$t("settlement.title")]))
        );
        return;
      }
      Settlement.findByTitle({ title: value }).then(function (res) {
        if (res.data.code === 200 && res.data.entity.id !== self.editObj.id) {
          callback(
            new Error(self.$t("rules.exist", [self.$t("settlement.title")]))
          );
          return;
        } else {
          callback();
        }
      });
    };
    var validateTitle = (rule, value, callback) => {
      const self = this;
      if (value == null || value === "") {
        callback(
          new Error(self.$t("rules.required", [self.$t("settlement.title")]))
        );
        return;
      }
      Settlement.findByTitle({ title: value }).then(function (res) {
        if (res.data.code === 200) {
          callback(
            new Error(self.$t("rules.exist", [self.$t("settlement.title")]))
          );
          return;
        } else {
          callback();
        }
      });
    };
    return {
      searchForm: {
        title: null,
        supplierName: null,
      },
      sorter: {
        sortBy: "settlements_id",
        sortIndicator: "desc",
      },
      users: [],
      payments: [],
      //
      currentRowIdx: null,
      currentRowId: null,
      showDF: false,
      row: null,
      // 编辑
      validateTitleEdit: validateTitleEdit,
      editDF: false,
      editObj: {
        title: null,
      },
      editDoing: false,
      // 新增
      validateTitle: validateTitle,
      suppliers: [],
      addDF: false,
      dateTypes: ["placeAt", "receiveAt", "supplierDeliveryAt"],
      addObj: {
        title: null,
        supplierId: null,
        _dateType: null,
        _date: null,
      },
      addDoing: false,
      //
      lineItemDF: false,
      //
      supplierCounts: [],
    };
  },
  computed: {
    implicit() {
      return {
        settleWith: "supplier",
      };
    },
  },

  created() {
    const self = this;
    Supplier.findByTenantId().then(function (res) {
      self.suppliers = res.data;
      if (self.suppliers.length !== 0) {
        for (const c of self.suppliers) {
          if (c.sourceTenantId == null) {
            Vue.set(c, "text", c.name + "（无简赢账户）");
          } else {
            Vue.set(c, "text", c.name);
          }
        }
      }
    });
  },
  methods: {
    getSupplierCount() {
      const self = this;
      Settlement.supplierCount().then(function (res) {
        if (res.status == 200) {
          self.supplierCounts = res.data.sort();
        } else {
          self.sysError();
        }
      });
    },

    //
    showDetail(row) {
      this.currentRowId = row.id;
      this.lineItemDF = true;
    },
    lineItemClose() {
      this.lineItemDF = false;
      this.loadData();
    },

    add() {
      const self = this;
      self.addObj.title = Util.serialNoSimple();
      self.addObj.customerId = null;
      self.addObj._dateType = null;
      self.addObj._date = null;
      self.addDoing = false;
      self.addDF = true;
    },
    selectSupplier() {
      const self = this;
      if (self.addObj.supplierId != null) {
        const selectSupplier = self.suppliers.find(
          (c) => c.id === this.addObj.supplierId
        );
        self.addObj.title = selectSupplier.name + Util.serialNoSimple();
      }
    },
    addSubmit() {
      const self = this;
      self.$refs.addObjForm.validate((valid) => {
        if (valid) {
          let obj = {
            supplierId: this.addObj.supplierId,
          };
          obj[this.addObj._dateType + "StartAt"] =
            Util.formatDate(this.addObj._date[0]) + " 00:00:00";
          obj[this.addObj._dateType + "EndAt"] =
            Util.formatDate(this.addObj._date[1]) + " 23:59:59";
          // console.log("===", obj);
          self.addDoing = true;
          Purchase.unSettle(obj).then(function (res) {
            if (res.status === 200) {
              self.addDoing = false;
              if (
                res.data.length === 0 ||
                (res.data.length !== 0 &&
                  res.data.filter((p) => p.workflowState !== "newly").length ===
                    0)
              ) {
                self.$message({
                  message: self.$t("text.noData"),
                  type: "warning",
                });
              } else {
                self.$router.push({
                  name: "fnReportsSupplierSettlementsNew",
                  params: { title: self.addObj.title },
                  query: obj,
                });
                self.addDF = false;
              }
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },

    // 核对
    verify(row, rowIndex) {
      const self = this;
      Settlement.verify(row.id).then(function (res) {
        if (res.status === 200) {
          self.$message({
            message: self.$t("prompt.verifySuccess"),
            type: "success",
          });
          self.records[rowIndex].verifyAt = Util.formatDate(new Date());
        } else {
          self.sysError();
        }
      });
    },
    // 核对
    selfVerify(row, rowIndex) {
      const self = this;
      Settlement.selfVerify(row.id).then(function (res) {
        if (res.status === 200) {
          self.$message({
            message: self.$t("prompt.selfVerifySuccess"),
            type: "success",
          });
          self.records[rowIndex].selfVerifyAt = Util.formatDate(new Date());
        } else {
          self.sysError();
        }
      });
    },

    // // 付款完毕
    // confirmPayOff(row, rowIndex) {
    //   const self = this;
    //   if (row.amount > row.payAmount) {
    //     self.$message({
    //       message: "未付款完，不能标记完成",
    //       type: "warning",
    //     });
    //     return;
    //   }
    //   if (confirm(this.$t("prompt.confirmPayOff"))) {
    //     Settlement.payOff(row.id).then(function (res) {
    //       if (res.status === 200) {
    //         self.$message({
    //           message: self.$t("action.paymentOff"),
    //           type: "success",
    //         });
    //         self.records[rowIndex].payoffAt = Util.formatDate(new Date());
    //       } else {
    //         self.sysError();
    //       }
    //     });
    //   }
    // },
    showClose() {
      this.loadData();
    },
    // 删除
    deleteRow(row) {
      const self = this;
      if (confirm(this.$t("prompt.confirmDelete"))) {
        Settlement.delete(row.id).then(function (res) {
          if (res.status === 200) {
            self.$message({
              message: self.$t("prompt.delSuccess"),
              type: "success",
            });
            self.loadData();
          } else {
            self.sysError();
          }
        });
      }
    },
    // 编辑
    edit(row, rowIndex) {
      const self = this;
      self.row = row;
      self.currentRowIdx = rowIndex;
      self.editObj.title = row.title;
      self.editDoing = false;
      self.editDF = true;
    },
    editSubmit() {
      const self = this;
      self.$refs.editObjForm.validate((valid) => {
        if (valid) {
          self.editDoing = true;
          Settlement.update(this.row.id, self.editObj).then(function (res) {
            self.editDoing = false;
            self.editDF = false;
            if (res.status === 200) {
              self.$message({
                message: self.$t("prompt.editSuccess"),
                type: "success",
              });
              self.records[self.currentRowIdx].title = self.editObj.title;
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },
    //
    getPayments(row) {
      const self = this;
      Payment.findBySettlementId(row.id).then(function (res) {
        if (res.status === 200) {
          self.payments = res.data;
        } else {
          self.sysError();
        }
      });
    },
    showRow(row) {
      this.currentRowId = row.id;
      this.showDF = true;
    },
    //-----
    dataProvider(params) {
      return Settlement.search(params);
    },
  },
};
</script>
